import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import PraetoidInterface from './application';

import '@praetoid/ui/styles.css';
import '~/assets/styles/theme-config.css';

Sentry.init({
	dsn: 'https://1fe00487fb00b261ea015eb8f9fdbcf7@o233708.ingest.us.sentry.io/4509962271260672',
	sendDefaultPii: true,
	enabled: import.meta.env.PROD
});

const el = document.getElementById('root') as HTMLElement;

const root = ReactDOM.createRoot(el, {
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.error(error, errorInfo);
	}),
	onCaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.error(error, errorInfo);
	}),
	onRecoverableError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.error(error, errorInfo);
	})
});

root.render(<PraetoidInterface />);
